<template>
    <TotemSearch
        v-model="searchPhrase"
        v-if="isDesktopView"
        v-on:clearSearch="onClearSearch"
        @keyup.enter.native="goToAllItemsList"
        class="search"
        :placeholder="$t('General.search')"
        topHeaderSearch
        :key="searchComponentKey"
    />
</template>

<script>
    import searchHelper from 'components/layout/mixins/searchHelper'
    export default {
        name: 'search',
        mixins: [searchHelper],
    }
</script>

<style lang="scss" scoped>
    .search {
        flex: 1;
        margin: 0;
    }
</style>
